<template>
  <div :class="{'grid-container': is_access('control'), 'no-control': !is_access('control')}">
    <div class="video-container">
      <video ref="video" autoplay controls muted style="width: 100%; height: 100%;"></video>
    </div>
    <div class="control-container" v-if="is_access('control')">
      <div class="control-title">{{title}}</div>
      <template v-for="mod in control_modules">
        <template v-for="control in get_presets(mod)">
          <v-btn :color="get_color(mod, control)" @click="send_control(mod, control.name)" class="control-button">
            <template v-if="is_processing(mod, control)">
              <v-progress-circular :value="20" :indeterminate="true" size="18"></v-progress-circular>
            </template>
            <template v-else>
              <span style="margin-left: 18px;"></span>
            </template>
            <span style="margin-right: 18px;">{{control.title}}</span>
          </v-btn>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import ChannelModel from '@/models/channel.js'
import InstanceModel from '@/models/instance.js'

import webrtc from '@/lib/webrtc_reader.js'
import Vue from 'vue'

export default {
  props: ["channel_id", "output_name"],

  data () {
    var ch = this.$cloudserver.channel("channels:"+this.channel_id);

    return {
      ws_channel: ch,
      control_ch: undefined,
      control_data: undefined,
      channel: this.convert_channel(ch.data),
      output: undefined,
      webrtc_outputs: undefined,
      webrtc_reader: undefined,
      is_control_param: true,
      processing: {}
    }
  },
  watch: {
    "ws_channel.data": {
      handler(newVal, oldVal) {
        if(typeof(newVal) != "undefined") {
          this.channel = this.convert_channel(newVal);
        }
      },
      deep: true
    },
    "instance": function(newVal) {
      if (typeof(newVal) != "undefined") {
        this.open_webrtc(this.output);
      }
    }

  },
  mounted () {
    this.is_control_param = this.$route.query.control;
    this.ws_channel.join();
  },
  beforeDestroy () {
    this.ws_channel.leave();
    if (typeof(this.control_ch) != "undefined") {
      this.control_ch.leave();
    }
  },
  methods: {
    get_presets(name) {
      if (typeof(this.control_data) != "undefined") {
        var spec = this.control_data[name+"__spec"];
        return spec.presets;
      }
      return [];
    },
    is_processing(mod, control) {
      if (this.processing[control.name] === true) return true;
      return false;
    },
    is_access(role) {
      if (this.is_control_param == "false") return false;
      if (this.$is_admin()) return true;

      if (Array.isArray(role)) {
        var ret = false;
        _.each(role, (r) => {
          if (this.is_access(r) == true) ret = true;
        })
        return ret;
      }
      var self = this;
      var groups = this.$store.getters.groups;
      var account = this.$store.state.account;
      if (typeof(account) == "undefined") return false;
      if (typeof(groups) == "undefined") return false;

      var channel_uuid = self.channel.uuid;
      var ret = false;
      _.each(groups, (group) => {
        var channels = group.channels;
        if (channels.includes(channel_uuid)) {
          var production_role = _.get(group, ["meta", "production_roles", account.id]);
          if (role == production_role) ret = true;
        }
      });
      return ret;
    },
    get_color(mod, control) {
      if (typeof(this.control_data) != "undefined") {
        var data = this.control_data[mod];
        var meta_state = _.get(control, ["meta", "state"]);
        if (typeof(meta_state) != "undefined") {
          var value = _.get(data, [meta_state["name"], meta_state["key"]]);
          if (value == meta_state["value"]) {
            if (this.processing[control.name] == true) {
              Vue.set(this.processing, control.name, false);
            }
            return "red";
          }
        }
      }
      return "";
    },
    send_control(mod, name) {
      if (typeof(this.control_ch) != "undefined") {
        var data = {}
        data[mod] = {
          "type": "presets",
          "value": [{"name": name}]
        }
        Vue.set(this.processing, name, true);
        this.control_ch.push("update", {"control": data});
      }
    },
    convert_channel(ch) {
      var self = this;
      this.webrtc_outputs = _.get(ch, ["configuration", "streamer", "config", "webrtc_outputs"]);
      this.output = _.find(this.webrtc_outputs, function(output) {
        if (output.name == self.output_name) return true;
      });

      if (typeof(this.control_ch) == "undefined" && typeof(ch.name) != "undefined") {
        this.control_ch = this.$socket.channel("system:instance_to_instance:"+ch.name);
        this.control_ch.on("status", (msg) => {
          this.control_data = msg["control"];
        });
        this.control_ch.join();
        this.control_ch.push("message", {"type": "state_request"});
      }

      return ch;
    },
    open_webrtc(output) {
      var self = this;

      if (typeof(self.webrtc_reader) != "undefined") {
        return;
      }

      var url = new URL(output.webrtc_name + '/whep',InstanceModel.studio_url(this.instance, 8889));
      this.webrtc_reader = new MediaMTXWebRTCReader({
        url: url,
        onError: (err) => {
          console.log("Webrtc error", err);
        },
        onTrack: (evt) => {
          self.$refs.video.srcObject = evt.streams[0];
        }
      });
    }
  },
  computed: {
    title () {
      return ChannelModel.title(this.channel);
    },
    control_modules() {
      if (typeof(this.control_data) != "undefined") {
        return _.filter(Object.keys(this.control_data), function(name) {
          if (!name.endsWith("__spec")) return true;
          return false;
        });
      }
      return [];
    },
    instance() {
      return ChannelModel.instance(this.channel);
    },
    is_visible() {
      return true;
    }
  }
}
</script>

<style scoped>
  .no-control {
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    width: 100%;
    height: 100%;
  }
  .grid-container {
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    display: grid;        
    grid-template-columns: 1fr 300px;
  }
  .video-container {
    background-color: #111;
  }
      
  .video-container video {
    background-color: #000;
    width: 100%;
    height: 100%;
  }

  .control-title {
    font-size: 18px; 
    background-color: #222; 
    margin-left: -10px; 
    margin-top: -10px; 
    height: 40px; 
    line-height: 40px; 
    width: 300px; 
    padding-left: 10px; 
    margin-bottom: 20px;
    white-space: nowrap;
  }
  .control-container {
    padding: 10px;
    margin-right: 10px;
  }
  .control-button {
    width: 100%;
  }
</style>